"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _7DAL4U2Wcjs = require('../__chunks/7DAL4U2W.cjs');


var _7XPYSHN7cjs = require('../__chunks/7XPYSHN7.cjs');
require('../__chunks/F7D3HWZN.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/toolbar/toolbar-separator.tsx
var TagName = "hr";
var useToolbarSeparator = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useToolbarSeparator2({ store, ...props }) {
    const context = _7DAL4U2Wcjs.useToolbarContext.call(void 0, );
    store = store || context;
    props = _7XPYSHN7cjs.useCompositeSeparator.call(void 0, { store, ...props });
    return props;
  }
);
var ToolbarSeparator = _PTOCUU2Dcjs.forwardRef.call(void 0, function ToolbarSeparator2(props) {
  const htmlProps = useToolbarSeparator(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.ToolbarSeparator = ToolbarSeparator; exports.useToolbarSeparator = useToolbarSeparator;
